import { range } from 'lodash';

export const monthsArray = {
    1: 'Januari',
    2: 'Februari',
    3: 'Maart',
    4: 'April',
    5: 'Mei',
    6: 'Juni',
    7: 'Juli',
    8: 'Augustus',
    9: 'September',
    10: 'Oktober',
    11: 'November',
    12: 'December',
};

export const getMonthOptions = includeAllOption => {
    const monthsOptions = Object.entries(monthsArray).map(([id, name]) => ({
        key: id,
        value: id,
        text: name,
    }));

    return includeAllOption
        ? [{ key: 0, value: 0, text: 'Alle maanden' }, ...monthsOptions]
        : monthsOptions;
};

export const getYearOptions = (startYear, endYear = null) => {
    const yearOptions = [];

    endYear = endYear ? endYear : calculateEndYear();

    for (let y = startYear; y <= endYear; y++) {
        yearOptions.push({ key: y, value: y, text: y });
    }

    return yearOptions;
};

export const calculateEndYear = () => {
    const currentYear = new Date().getFullYear();

    return isCurrentMonthGreaterOrEqualToOctober()
        ? currentYear + 1
        : currentYear;
};

export const isCurrentMonthGreaterOrEqualToOctober = () =>
    new Date().getMonth() >= 9;

export const getYearsRange = (startYear, endYear = null) => {
    endYear = endYear ? endYear : calculateEndYear();

    return range(startYear, endYear + 1);
};
